/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticket_Action_Comment_ShortInputs */

const en_ticket_action_comment_short = /** @type {(inputs: Ticket_Action_Comment_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add a comment`)
};

const ja_ticket_action_comment_short = /** @type {(inputs: Ticket_Action_Comment_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コメントを追加`)
};

const fr_ticket_action_comment_short = /** @type {(inputs: Ticket_Action_Comment_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter un commentaire`)
};

const de_ticket_action_comment_short = /** @type {(inputs: Ticket_Action_Comment_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kommentar hinzufügen`)
};

/**
* | output |
* | --- |
* | "Add a comment" |
*
* @param {Ticket_Action_Comment_ShortInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const ticket_action_comment_short = /** @type {((inputs?: Ticket_Action_Comment_ShortInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticket_Action_Comment_ShortInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticket_action_comment_short(inputs)
	if (locale === "ja") return ja_ticket_action_comment_short(inputs)
	if (locale === "fr") return fr_ticket_action_comment_short(inputs)
	return de_ticket_action_comment_short(inputs)
});